import { getConfig } from "@arkadium/jarvis/dist/v2";

export type JarvisResponse = Awaited<ReturnType<typeof getConfig>>;
export type Config = JarvisResponse['videoConfig'];

export class JarvisService {
  public fetched: Promise<JarvisResponse>;
  protected host: string;

  constructor(host: string) {
    this.host = host;
    this.fetched = getConfig(this.host);
  }

  fetch() {
    return this.fetched;
  }
}
